import { addDoc, collection } from "firebase/firestore";
import { DocumentState } from "~/types/enums/DocumentState";
import type { ImportedChecklist } from "~/types/ImportedChecklist";
import type { Revision } from "~/types/Revision";

export const useCreateHtmlRevision = async ({
  documentId,
  html,
  headers,
  importedChecklist,
  submittedDocumentState,
}: {
  documentId: string;
  html: string;
  headers?: Revision["headers"];
  importedChecklist?: ImportedChecklist;
  submittedDocumentState: DocumentState;
}) => {
  // I should create the media object instead. Let's see.
  const revisionRef = collection(
    useFirestore(),
    `/documents/${documentId}/revisions`
  );

  const revisionData: Partial<Revision> = {
    documentId,
    externalId: documentId,
    lastUpdatedTimestamp: Date.now(),
    html,
  };

  if (headers && headers.length > 0) {
    revisionData.headers = headers;
  }

  if (importedChecklist) {
    revisionData.importedChecklist = importedChecklist;
  }

  await addDoc(revisionRef, revisionData);

  // Update the document state
  await useDocuments().updateDocumentStateById(
    documentId,
    submittedDocumentState
  );
};
